import type { QuoteTemplateAttachment } from '@common/types/quoteTemplates';
import type { UploadedDocument } from './DocumentSection';

/** A file saved on an intake template, as a document in the documents section */
export function toTemplateDocument({
    fileId,
    fileName,
    fileType,
}: QuoteTemplateAttachment): UploadedDocument {
    return { id: fileId, name: fileName, type: fileType, size: null, isFromTemplate: true };
}
